/**
 * Tooltip component that displays a tooltip near a target element.
 * Adapted logic from https://codesandbox.io/p/sandbox/how-to-make-an-extremely-reusable-tooltip-component-with-react-and-nothing-else-7opo3
 */
import { useState, PropsWithChildren, HTMLAttributes } from 'react';

import styles from './Tooltip.module.scss';

interface TpTooltipProps extends HTMLAttributes<HTMLDivElement> {
  content: string; // Content of the tooltip
  direction?: 'top' | 'bottom' | 'left' | 'right'; // Direction of the tooltip
  delay?: number; // Delay before showing the tooltip in milliseconds
}

const Tooltip = ({ content, direction, delay, children, ...props }: PropsWithChildren<TpTooltipProps>) => {
  let timeout: number | undefined;
  const [active, setActive] = useState(false);

  const showTip = () => {
    timeout = setTimeout(() => {
      setActive(true);
    }, delay || 200);
  };

  const hideTip = () => {
    clearInterval(timeout);
    setActive(false);
  };

  return (
    // Pass props to the wrapper div to allow for additional HTML attributes
    <div className={styles.wrapper} onMouseEnter={showTip} onMouseLeave={hideTip} {...props}>
      {children}
      {active && <div className={`${styles.tooltip} ${styles[direction || 'top']}`}>{content}</div>}
    </div>
  );
};

export default Tooltip;
